/**
 * Parse a date-only string (YYYY-MM-DD) as local time, not UTC.
 * This prevents off-by-one errors when working in timezones with positive offsets.
 */
export const parseLocalDate = (dateStr: string): Date => {
    const [year, month, day] = dateStr.split('-').map(Number);
    return new Date(year, month - 1, day);
};

/**
 * Format a Date as YYYY-MM-DD in local time.
 * This is safer than toISOString().split('T')[0] which can return the previous day
 * for local midnight in timezones with positive offsets.
 */
export const formatLocalDate = (date: Date): string => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};
